import request from '@/libs/request'

//基地信息 列表
export function landBaseListApi (data) {
  return request({
    url: `landBase/landBase`,
    method: 'get',
    params: data
  })
}

//基地信息 详情
export function landBaseInfoApi (id) {
  return request({
    url: `landBase/landBase/` + id,
    method: 'get'
  })
}


//基地信息 编辑/添加
export function landBaseSaveApi (data) {
  return request({
    url: `landBase/landBase`,
    method: 'post',
    data: data
  })
}

//基地信息 删除
export function landBaseDelApi (id) {
  return request({
    url: `landBase/landBase/` + id,
    method: 'delete',
  })
}

//基地信息 所有数据 下拉
export function landBaseAllApi (data = {}) {
  return request({
    url: `landBase/landBaseApi/all`,
    method: 'get',
    params: data
  })
}

// 基地信息 所有数据
export function landBaseListAllApi (data = {}) {
  return request({
    url: `landBase/landBaseApi/listAll`,
    method: 'get',
    params: data
  })
}


